export default "__VITE_ASSET__CZ19HF69__"